
import { FreelancerCard, FreelancerProps } from "./FreelancerCard";
import { useState, useRef } from "react";
import { Badge } from "@/components/ui/badge";
import { motion } from "framer-motion";
import { ListFilter } from "lucide-react";
import { GridControls } from "./GridControls";
import { FreelancerSlider } from "./FreelancerSlider";
import { GridContainer } from "./GridContainer";


export type GridLayoutType = 'compact' | 'comfortable' | 'spacious' | 'slider';

interface FreelancerGridProps {
  freelancers: (FreelancerProps & { matchScore?: number })[];
  isLoading?: boolean;
  showMatchScore?: boolean;
  navigateToFreelancePageDetails?: any
}

export const FreelancerGrid = ({ 
  freelancers, 
  isLoading = false, 
  showMatchScore = false,
  navigateToFreelancePageDetails
}: FreelancerGridProps) => {
  const [gridLayout, setGridLayout] = useState<GridLayoutType>('comfortable');
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef<HTMLDivElement>(null);

  // Render loading state
  if (isLoading) {
    return (
      <div className="space-y-8">
        <div className="flex justify-between items-center">
          <Badge variant="outline" className="px-2 py-1 bg-sky-50 text-sky-700 border-sky-200">
            <ListFilter className="h-3.5 w-3.5 mr-1" />
            <span>Loading results...</span>
          </Badge>
          <div className="flex space-x-1">
            {Array.from({ length: 4 }).map((_, index) => (
              <div key={index} className="h-8 w-8 bg-gray-100 animate-pulse rounded"></div>
            ))}
          </div>
        </div>
        <GridLoadingSkeleton />
      </div>
    );
  }

  // Render slider view
  if (gridLayout === 'slider') {
    return (
      <div className="space-y-8">
        {/* <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <FreelancerCountBadge count={freelancers.length} />
          <GridControls gridLayout={gridLayout} onLayoutChange={setGridLayout} />
        </div> */}
        
        <FreelancerSlider 
          freelancers={freelancers}
          currentSlide={currentSlide}
          setCurrentSlide={setCurrentSlide} 
          sliderRef={sliderRef}
          showMatchScore={showMatchScore}
        />
      </div>
    );
  }

  // Render grid layouts
  return (
    <div className="space-y-8">
      {/* <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <FreelancerCountBadge count={freelancers.length} />
        <GridControls gridLayout={gridLayout} onLayoutChange={setGridLayout} />
      </div> */}
      
      <GridContainer 
        handleFreelancerDetail = {navigateToFreelancePageDetails}
        gridLayout={gridLayout} 
        freelancers={freelancers} 
        showMatchScore={showMatchScore} 
      />
    </div>
  );
};

// Helper component for displaying freelancer count
const FreelancerCountBadge = ({ count }: { count: number }) => (
  <Badge variant="outline" className="px-3 py-1.5 bg-gradient-to-r from-sky-50 to-emerald-50 text-sky-700 border-sky-200 shadow-sm">
    <ListFilter className="h-3.5 w-3.5 mr-1.5" />
    <span>Showing {count} professionals</span>
  </Badge>
);

// Helper component for loading skeleton
const GridLoadingSkeleton = () => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    {Array.from({ length: 6 }).map((_, index) => (
      <div key={index} className="h-[420px] bg-gradient-to-b from-gray-100 to-gray-50 animate-pulse rounded-xl shadow-sm"></div>
    ))}
  </div>
);
